import React from "react";
import ServicesCard from "../../../components/ServicesCard";
import { motion } from "framer-motion";

const OurExpertise = () => {
  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-backgroundColor px-2 md:px-10 ">
      {/* Header */}
      <div className="flex flex-col items-center justify-center md:px-24">
        <motion.h2
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="font-CrimsonText font-bold text-2xl md:text-4xl text-primaryColor pb-5"
        >
          Our Expertise
        </motion.h2>

        <motion.p
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          className="pb-5 font-CrimsonText font-normal text-base lg:text-xl text-textColor text-center"
        >
          We provide engineering and operations support across data centers and
          production facilities, including oil, gas, and produced-water
          processing systems.
        </motion.p>
      </div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: {},
          visible: { transition: { staggerChildren: 0.2 } },
        }}
        className="w-full flex-col xl:flex-row flex items-center justify-center lg:justify-between gap-10 my-5 md:my-10"
      >
        <motion.div
          variants={{
            hidden: { y: 50, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
          }}
        >
          <ServicesCard title="Oil, Gas & Produced Water Treatment & Management" />
        </motion.div>
        <motion.div
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.2 } },
          }}
          className=" flex flex-col gap-10"
        >
          {" "}
          <motion.div
            variants={{
              hidden: { y: 50, opacity: 0 },
              visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
            }}
          >
            <ServicesCard title="Data Centers" />
          </motion.div>
          <motion.div
            variants={{
              hidden: { y: 50, opacity: 0 },
              visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
            }}
          ></motion.div>
          <motion.div
            variants={{
              hidden: { y: 50, opacity: 0 },
              visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
            }}
          >
            <ServicesCard title="Engineering, Procurement, Construction, Installation, Commissioning, & Project Management Services" />
          </motion.div>
        </motion.div>
        <motion.div
          variants={{
            hidden: { y: 50, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
          }}
        >
          <ServicesCard title="Quality, Health, Safety and Environment" />
          {/* <ServicesCard title="Asset Integrity & Management" /> */}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default OurExpertise;
